import { EReceiving, ReceivingAction } from '../actions/receiving-action';
import { intialReceivingState } from '../state/receiving-state';
import { filter } from 'rxjs/operators';
import { ReceivingList, PurchaseModel } from '../../models';
import { state } from '@angular/animations';


export function ReceivingReducer(state = intialReceivingState, action: ReceivingAction): any  {
    switch (action.type) {
        case EReceiving.GetReceiving: {
            return{
                ...state,
                GetReceiving: action.payload
            };
        }
        case EReceiving.GetReceivingSuccess: {
            return{
                ...state,
                GetReceivingSuccess: action.payload
            };
        }
        case EReceiving.GetReceivingViewModel: {
            return{
                ...state,
                GetReceivingViewModel: receivingRestructure(state.GetReceivingSuccess, action.payload)
            };
        }
        case EReceiving.GetReceivingDetailById: {
            return{
                ...state,
                // GetReceivingDetailById: state.GetReceivingSuccess.filter(x=> x.id === action.payload)
                GetReceivingDetailById: action.payload
            };
        }
        case EReceiving.GetReceivingDetailByIdSucess: {
            return{
                ...state,
                GetReceivingDetailByIdSucess: action.payload
            };
        }
        case EReceiving.GetReceivingSearch: {
            return{
                ...state,
                GetReceivingSearch: searchState(action.payload, state)
            };
        }
        case EReceiving.GetReceivingSorting: {
            return{
                ...state,
                GetReceivingSearch: sortingState(action.payload, state)
            };
        }
        case EReceiving.GetPoSearchbyId: {
            return{
                ...state,
                GetPoSearchbyId: SearchpoSummary(state, action.payload)
            };
        }
        case EReceiving.GetPoSearchSuccess: {
            return{
                ...state,
                GetPoSearchSuccess: action.payload
            };
        }
        case EReceiving.GetLookupDetail: {
            return{
                ...state,
                GetLookupDetail: action.payload
            };
        }
        case EReceiving.GetLookUpDetailSuccess: {
            return{
                ...state,
                GetLookUpDetailSuccess: action.payload
            };
        }
        case EReceiving.GetLookUpGridSuccess: {
            return{
                ...state,
                GetLookUpGridSuccess: addnewItem(state, action.payload)
            }
        }
        case EReceiving.GetItemList: {
            return{
                ...state,
                GetItemList: action.payload
            };
        }
        case EReceiving.GetItemListSuccess: {
            return{
                ...state,
                GetItemListSuccess: action.payload
            };
        }
        case EReceiving.GetSupplierItemNumberSuccess: {
            return{
                ...state,
                GetSupplierItemNumberSuccess: action.payload
            };
        }
        case EReceiving.GetItemPoSummary: {
            return{
                ...state,
                GetItemPoSummary: action.payload
            };
        }
        case EReceiving.GetItemPoSummarySuccess: {
            return{
                ...state,
                GetItemPoSummarySuccess: action.payload
            };
        }
        case EReceiving.GetSupplierList: {
            return{
                ...state,
                GetSupplierList: action.payload
            };
        }
        case EReceiving.GetSupplierSuccess: {
            return{
                ...state,
                GetSupplierSuccess: action.payload
            };
        }
        case EReceiving.GetSearchSupplier: {
            return{
                ...state,
                GetSearchSupplier: searchSupplier(state, action.payload)
            };
        }
        case EReceiving.GetLocation: {
            return{
                ...state,
                GetLocation: action.payload
            };
        }
        case EReceiving.GetLocationSuccess: {
            return{
                ...state,
                GetLocationSuccess: action.payload
            };
        }
        case EReceiving.PostReceiving: {
            return{
                ...state,
                PostReceiving: action.payload
            };
        }
        case EReceiving.PostReceivingSuccess: {
            return{
                ...state,
                PostReceivingSuccess: action.payload
            };
        }
        case EReceiving.SaveReceiving: {
            return{
                ...state,
                SaveReceiving: action.payload
            };
        }
        case EReceiving.SaveReceivingSucess: {
            return{
                ...state,
                SaveReceivingSucess: action.payload
            };
        }
        case EReceiving.ReceivingformDetails: {
            return{
                ...state,
                ReceivingformDetails: action.payload
            };
        }
        default:
       return state;
    }
}

function searchSupplier(supplierState: any, suplierPayload: any) {
    try {
        if (
            supplierState !== null &&
            suplierPayload !== undefined &&
            supplierState.GetSupplierSuccess && 
            supplierState.GetSupplierSuccess.value &&
            suplierPayload &&
            suplierPayload !== null ) {
                return supplierState.GetSupplierSuccess.value.filter((x: any)=> {
                    const index = x.Name.toString().toLowerCase().indexOf(suplierPayload.toString().toLowerCase());
                    if ( index > -1 ) {
                        return x;
                        }
                });
            }
    } catch ( error ) {
        console.error('searchSupplier error message', error);
    }
}

function SearchpoSummary(PoState: any, PoPayload: any) {
   try {
    if (PoState !== null && PoPayload !== undefined && PoState.GetItemPoSummarySuccess && PoPayload && PoPayload !== null ) {
        return PoState.GetItemPoSummarySuccess.filter(x => {
          const index = x.Id.toString().toLowerCase().indexOf(PoPayload.toString().toLowerCase());
          if ( index > -1 ) {
              return x;
          }
        });
     }
     console.log(PoState)
   } catch (error) {
      console.log('error thown SearchpoSummary', error);
   }
}

function addnewItem(ItemState: any, ItemPayload: any) {
    try {
        if (ItemPayload !== null) {
            ItemState.GetLookUpGridSuccess.unshift(ItemPayload[0])
            return [...ItemState.GetLookUpGridSuccess];
        }
    } catch (error) {

    }
    return ItemPayload;
}
  


function receivingRestructure(receivingData: any, payloadParams?: any) {
    let IteamDataReceiving  = [];
    if ( receivingData !== null && payloadParams == null ) {
        const receivingDataList = receivingData['value'];
        if( receivingDataList && receivingDataList.length > 0 ){
            receivingDataList.forEach( (element: any) => {
                const IteamData = {} as ReceivingList;
                IteamData.InvoiceId = element.InvoiceId;
                IteamData.InvoiceNumber = element.InvoiceNumber;
                IteamData.DueDate = element.InvoiceDueDate;
                IteamData.IsReceiver = element.IsAPVoucher;
                IteamData.LocationId = element.ReceivingHeadLocation.Id;
                IteamData.PONumber = element.PONumber;
                IteamData.POHeadId = element.POHeadId;
                IteamData.PostDate = element.PostDate;
                IteamData.Reason = element.Reason;
                IteamData.SupplierId = element.SupplierId;
                IteamData.SupplierName = element.ReceivingHeadSupplier.Name;
                IteamData.LocationName = element.ReceivingHeadLocation.Name;
                IteamData.TotalAmount = element.Amount;
                IteamData.Id = element.Id
                IteamData.TotalItem = element['ReceivingDetails'].length;
                IteamData.BaseCurrencyId = element.BaseCurrencyId;
                IteamData.TransactionCurrencyId = element.TransactionCurrencyId;
                IteamData.ExchangeRate =  Number(sessionStorage.getItem('SupplierExchangeRate'));
                IteamDataReceiving.push(IteamData);
            });
            return IteamDataReceiving;  
        }
    } else {
        return IteamDataReceiving = payloadParams;
    }
}


function searchState(payload: any, state: any) {
    let searchElement = [];
    receivingRestructure(state.GetReceivingSuccess).filter(x => {
        if ( payload.keyValue.length > 0) {
        payload.keyName.forEach(element => {
            const index = x [element].toString().toLowerCase().indexOf(payload.keyValue.toString().toLowerCase());
            if ( index > -1 ) {
                searchElement.push(x);
            }
        });
        } else {
            searchElement = receivingRestructure(state.GetReceivingSuccess);
        }
    });
    return searchElement;
}

function sortingState(payload: any, state: any) {
   if ( payload !== null ) {
    let sortingReturn: any;
    let sortOrder: any = 1;
    if (payload && payload.sortingMethod === 'desc') {
        sortOrder = -1;
    }
    sortingReturn = state.GetReceivingViewModel.sort( function (a, b) {
        const result = (a[payload.key].toLowerCase() < b[payload.key].toLowerCase()) ? -1 :
        (a[payload.key].toLowerCase() > b[payload.key].toLowerCase()) ? 1 : 0;
        return result * sortOrder;
      });
    return sortingReturn;
   }
}

